import type { Brand as ProductBrand } from 'src/types';
import type { Brand } from 'schema-dts';

export function brand(productBrand: ProductBrand): Brand {
  return { '@type': 'Brand', name: productBrand.name };
}
